import { makeStyles } from '@material-ui/core';
import { reskinStyles } from 'core/components/theme/theme-variant';

export default makeStyles((theme) => ({
  resultsContainer: ({ mode }) => {
    if (mode === 'modal') {
      return {
        backgroundColor: theme.colorPalette.beige_25,
        boxShadow: 'none',
        ...reskinStyles(theme, { marginLeft: theme.spacing(12), marginRight: theme.spacing(12) })
      };
    }
    // Reskin: the search results are the screen's highlight card.
    return reskinStyles(theme, theme.cardStyles.highlight);
  },
  tableRow: {
    height: 48
  },
  cell: {
    display: 'inline',
    height: 48,
    width: '100%'
  }
}));
